<template>
  <v-container fluid class="pa-8">
    <v-row align="center" class="mb-8">
      <v-col cols="12">
        <v-btn text color="grey" @click="$router.go(-1)" class="mb-4 px-0">
          <v-icon left small>mdi-arrow-left</v-icon> Volver al Monitor
        </v-btn>
        <h2 class="text-h3 font-weight-black white--text mb-2">Comparativa de Abastecimiento</h2>
        <p class="grey--text">Analizando costos de {{ productos.length }} productos entre {{ proveedoresComparados.length }} proveedores.</p>
      </v-col>
    </v-row>

    <div v-if="loading" class="text-center py-16">
      <v-progress-circular indeterminate color="blue" size="64"></v-progress-circular>
      <p class="mt-4 grey--text italic">Procesando tarifarios...</p>
    </div>

    <v-row v-else>
      <v-col v-for="prod in productos" :key="prod.producto_id" cols="12">
        <v-card flat class="rounded-xl border-subtle mb-4 overflow-hidden bg-row">
          <v-row no-gutters align="center">
            
            <v-col cols="12" md="4" class="pa-6 border-right-dark">
              <div class="d-flex align-center mb-1">
                <span class="text-overline blue--text font-weight-black">SKU: {{ prod.sku_interno }}</span>
              </div>
              <div class="white--text font-weight-black text-h6">{{ prod.nombre }}</div>
            </v-col>
            
            <v-col v-for="p in proveedoresComparados" :key="p.id" class="pa-4 text-center border-right-dark">
              <div class="grey--text text-overline mb-2 text-truncate px-2">{{ p.nombre }}</div>
              
              <template v-if="hasPrice(prod, p.id)">
                <div :class="isBestPrice(prod, p.id) ? 'green--text font-weight-black' : 'white--text'"
                     class="text-h5">
                  ${{ formatMoney(prod.precios[p.id]) }}
                </div>
                
                <v-fade-transition>
                  <div v-if="isBestPrice(prod, p.id)" class="green--text text-caption font-weight-bold mt-1">
                    <v-icon x-small color="green" class="mr-1">mdi-check-decagram</v-icon>
                    MEJOR COSTO
                  </div>
                </v-fade-transition>
              </template>

              <div v-else class="grey--text text-h6 italic">---</div>
            </v-col>

            <v-col cols="12" md="1" class="text-center pa-4">
               <v-btn icon color="blue lighten-2" title="Agregar a orden de compra sugerida">
                 <v-icon>mdi-cart-plus</v-icon>
               </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ProveedoresAPI from "@/api/proveedores/proveedor";
import ListaDePrecioAPI from "@/api/proveedores/listaDePrecio";



export default {
  name: "ListasPrecioComparar",
  data: () => ({
    loading: false,
    proveedoresComparados: [],
    productos: []
  }),
  methods: {
    hasPrice(producto, proveedorId) {
      return producto.precios && producto.precios[proveedorId] !== undefined;
    },

    isBestPrice(producto, proveedorId) {
      if (!this.hasPrice(producto, proveedorId)) return false;

      // Extraemos solo los valores numéricos de los precios
      const listaPrecios = Object.values(producto.precios).map(Number);
      
      // Si solo hay un proveedor con precio, no lo marcamos como "mejor" para no confundir
      if (listaPrecios.length < 2) return false;

      const minPrice = Math.min(...listaPrecios);
      return Number(producto.precios[proveedorId]) === minPrice;
    },

    formatMoney(value) {
      return Number(value).toLocaleString('es-AR', { minimumFractionDigits: 2 });
    },

    async fetchData() {
      const ids = this.$route.query.ids;
      if (!ids) return this.$router.push({ name: 'empresa.proveedores.listasdeprecio' });

      this.loading = true;
      try {
        const response = await ListaDePrecioAPI.compararListas(ids);
        // Mapeamos según tu respuesta de servidor
        this.proveedoresComparados = response.data.proveedores;
        this.productos = response.data.productos; 
      } catch (e) {
        console.error("Error cargando comparativa", e);
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style scoped>
.bg-row {
  background-color: rgba(255, 255, 255, 0.02) !important;
  border: 1px solid #333 !important;
  transition: background-color 0.2s;
}
.bg-row:hover {
  background-color: rgba(255, 255, 255, 0.04) !important;
}
.border-right-dark {
  border-right: 1px solid #333;
}
/* Quitar borde al último elemento en móviles */
@media (max-width: 960px) {
  .border-right-dark { border-right: none; border-bottom: 1px solid #333; }
}
.border-subtle { border: 1px solid #333 !important; }
.italic { font-style: italic; }
</style>